/** Etichette delle famiglie di scarto, per mostrarle nelle liste.
 *
 * La fonte di verità è la tassonomia nel backend
 * (`src/services/discard_families.py`), che le invia già risolte dentro la
 * risposta delle statistiche. Qui servono per un caso diverso: quando si arriva
 * alla lista da un drill-down, la chiave è nell'URL e non c'è nessuna risposta
 * statistiche da cui leggere l'etichetta.
 *
 * Duplicazione consapevole e circoscritta: se una chiave non è mappata, si mostra
 * la chiave grezza invece di un trattino, così una famiglia nuova resta leggibile
 * anche prima di essere aggiunta qui.
 */

export const DISCARD_FAMILY_LABELS: Record<string, string> = {
  errore_sistema: "Il sistema ha sbagliato",
  aggiornamento_pratica_esistente: "Aggiornamento su pratica esistente",
  duplicato: "Duplicato di una pratica già gestita",
  ordine_fatturazione: "Ordine di fatturazione",
  preventivo: "Preventivo o sua approvazione",
  manutenzione_programmata: "Manutenzione ordinaria o programmata",
  agenzia_interinale: "Agenzia interinale o candidature",
  comunicazione_commerciale: "Circolare, promozione o comunicazione fornitore",
  incomprensibile: "Illeggibile o incomprensibile",
  fuori_perimetro: "Altro fuori perimetro",
  altro: "Non classificabile",
};

/** Famiglie che rappresentano un fallimento nostro, non un'email fuori perimetro. */
export const SYSTEM_FAILURE_FAMILIES = new Set(["errore_sistema"]);

export function discardFamilyLabel(key: string): string {
  return DISCARD_FAMILY_LABELS[key] ?? key;
}
